import React from 'react'
import { NormalText } from './normal-text'

export const StoreNameText = ({children}) => (
    <div style={{
        borderLeft: 'solid 3px #71c18c',
        margin: '1em 0',
        paddingLeft: '10px'
    }}>
        <NormalText bold={true} fontSize={'1.25em'}>
            {children}
        </NormalText>
    </div>
)